import { render, staticRenderFns } from "./DashboardProdutoresMaps.vue?vue&type=template&id=1650c32e&scoped=true&"
import script from "./DashboardProdutoresMaps.vue?vue&type=script&lang=js&"
export * from "./DashboardProdutoresMaps.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProdutoresMaps.vue?vue&type=style&index=0&id=1650c32e&scoped=true&lang=css&"
import style1 from "./DashboardProdutoresMaps.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650c32e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
